import * as React from 'react';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import { ApiStore } from '../../../stores/ApiStore';
import * as ApiTypes from '../../../models/ApiTypes';
import { bind, inject } from '../../../utils/decorators';
import { ControlLabel, FormControl, Button, InputGroup, FormGroup } from 'react-bootstrap';
import FaIcon from '../../site/FaIcon';

interface IAuftragAdresseUebernehmenProps {
  adressArt: ApiTypes.AdressArt;
  onUebernehme: (adresse: ApiTypes.IAdresse) => void;
}

/** Komponente für Eingabe und Übernahme der Daten zu einer Adresse */
@observer
export default class AuftragAdresseUebernehmen extends React.Component<IAuftragAdresseUebernehmenProps, {}> {

  @inject(ApiStore) apiStore: ApiStore;

  @observable kennung: string = '';
  @observable adresseVorhanden: boolean | undefined = undefined;
  @observable requestInProgress: boolean = false;

  private abrufTimeoutRef: number = 0;

  private bezeichner: string = '';
  private label: string = '';
  private platzhalter: string = '';

  constructor(props: IAuftragAdresseUebernehmenProps) {
    super(props);
    if (this.props.adressArt === ApiTypes.AdressArt.Auftraggeber) {
      this.bezeichner = 'Adresse';
      this.label = 'Aus Adress-ID';
      this.platzhalter = 'Nummer der Adresse';
    } else {
      this.bezeichner = 'Untersuchungsstelle';
      this.label = 'Aus Untersuchungsstelle';
      this.platzhalter = 'Kennung der ÜO';
    }
  }

  @bind @action setRequestInProgress(value: boolean) {
    this.requestInProgress = value;
  }

  pruefeAdresseVorhandenDelayed() {
    if (this.abrufTimeoutRef > 0) {
      window.clearTimeout(this.abrufTimeoutRef);
      this.abrufTimeoutRef = 0;
    }
    const validateTimeoutInMs = 500;
    this.abrufTimeoutRef = window.setTimeout(() => { this.pruefeAdresseVorhanden(); }, validateTimeoutInMs);
  }

  @bind chk() {
    if (this.props.adressArt === ApiTypes.AdressArt.Auftraggeber) {
      return this.apiStore.adresseVorhanden(this.kennung);
    } else {
      return this.apiStore.untersuchungsstelleVorhanden(this.kennung);
    }
  }

  @bind apl() {
    if (this.props.adressArt === ApiTypes.AdressArt.Auftraggeber) {
      return this.apiStore.adresseDaten(this.kennung);
    } else {
      return this.apiStore.untersuchungsstelleAdresse(this.kennung);
    }
  }

  @bind async pruefeAdresseVorhanden() {
    if (this.kennung !== '') {
      this.setRequestInProgress(true);
      const response = await this.chk();
      if (response.ok) {
        this.setAdresseVorhanden(response.json.vorhanden);
      }
      this.setRequestInProgress(false);
    } else {
      this.setAdresseVorhanden(false);
    }
  }

  @bind @action async uebernehme() {
    if (this.kennung !== '') {
      const response = await this.apl();
      if (response.ok) {
        this.props.onUebernehme(response.json);
      }
    }
  }

  @bind @action setAdresseVorhanden(value: boolean) {
    this.adresseVorhanden = value;
  }

  @bind @action handleKennungChanged(event: React.FormEvent<FormControl>) {
    this.kennung = (event.target as HTMLInputElement).value;
    this.pruefeAdresseVorhandenDelayed();
  }

  renderAbfrageStatus() {
    if (this.kennung === '') {
      return <div style={{marginTop: '15px'}}>&nbsp;</div>;
    }
    if (this.requestInProgress) {
      return <div style={{marginTop: '15px'}}><FaIcon icon="spinner" />Daten werden abgerufen...</div>;
    }
    if (this.adresseVorhanden) {
      return <div className="value-success" style={{marginTop: '15px'}}><FaIcon icon="check" />Zu dieser {this.bezeichner} liegen Adressinformationen vor</div>;
    }
    if (this.adresseVorhanden === false) {
      return <div style={{marginTop: '15px'}}><FaIcon icon="question" />Zu dieser {this.bezeichner} liegen keine Adressinformationen vor</div>;
    }
    return <div style={{marginTop: '15px'}}>&nbsp;</div>;
  }

  render() {
    // Art des HTML-Input Elements je nach Datentyp steuern, Adressen müssen immer numerisch sein
    const type = (this.props.adressArt === ApiTypes.AdressArt.Auftraggeber) ? 'number' : 'text';
    return (
      <div style={{marginTop: '15px'}}>
        <FormGroup>
          <ControlLabel>{this.label}</ControlLabel>
          <InputGroup>
            <FormControl type={type} label="Kennung" placeholder={this.platzhalter} onChange={this.handleKennungChanged} value={this.kennung} />
            <InputGroup.Button>
              <Button bsStyle="success" className="btn-group" disabled={!this.adresseVorhanden} onClick={() => this.uebernehme()}>Übernehmen</Button>
            </InputGroup.Button>
          </InputGroup>
          {this.renderAbfrageStatus()}
        </FormGroup>
      </div>);
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/auftraege/adressen/AuftragAdresseUebernehmen.tsx